import { ChangeDetectionStrategy, Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { TemplateRefDiamondsService } from './template-ref-diamonds.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { SUBSCRIPTION_PRICE_MAP } from 'src/app/shareModule/constant/subscription';
import Swal from 'sweetalert2';
import { selectUser } from 'src/app/shareModule/states/user-details/user-details.selector';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/shareModule/states/app.state';
import { loadUser } from 'src/app/shareModule/states/user-details';

@Component({
  selector: 'app-diamonds-popup',
  templateUrl: './diamonds-popup.component.html',
  styleUrl: './diamonds-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DiamondsPopupComponent implements OnInit {
  @ViewChild('diamondsPopup', { static: true }) diamondsPopup: TemplateRef<any>;
  showList: boolean = false;
  subscriptions: boolean = false;
  public user: any;
  /**
   * Constructor
   */
  constructor(
    private toastr: ToastrService,
    private local: LocalServiceService,
    private templateRefDiamondsService: TemplateRefDiamondsService,
    private customerService: CustomerService,
    private store: Store<AppState>,
    @Inject("WINDOW") private window: any,
  ) { }

  ngOnInit(): void {
    this.store.select(selectUser).subscribe((user) => {
      if (user?.id) {
        this.user = user;
      }
    });
  }

  ngAfterViewInit() {
    this.templateRefDiamondsService.setDiamondsPopup(this.diamondsPopup);
    this.store.dispatch(loadUser({}));
  }

  handleSubscribe(
    token: string,
    subc: number = 0,
    notification_code: string = 'DEFAULT'
  ) {
    const priceMap = SUBSCRIPTION_PRICE_MAP;

    const selectedPrice = priceMap[token];
    if (!selectedPrice) {
      return;
    }

    if (selectedPrice.type != 'diamond') {
      if (this.user?.level < 5) {
        this.toastr.error(
          'You have to be level 5 and above to subscribe or purchase tokens'
        );
        return;
      }
    }

    this.local.alertLoading({ message: 'Processing the Request' });

    this.customerService
      .checkoutCreate({
        userId: this.user?.id,
        productId: selectedPrice.priceId,
        productType: selectedPrice.type,
        productName: selectedPrice.name,
        productPrice: selectedPrice.price,
        totalAmount: selectedPrice.price,
        paymentMethod: 'stripe',
      })
      .subscribe({
        next: (response: any) => {
          this.local.alertLoading({
            title: 'Order Created Successfully',
            message: 'Please wait while we redirect you to the payment page',
          });
          this.window.location.href = response.body.url;
        },
        error: (error) => {
          this.toastr.error(
            error.error.message || 'Subscription creation failed'
          );
          Swal.close();
        },
      });
  }

  handleManageSubscription() {

    let formData = new FormData();
    formData.append('userId', this.user?.id);

    this.local.alertLoading({ message: 'Processing the Request' });
    this.customerService.checkoutManage(formData).subscribe({
      next: (response: any) => {
        this.local.alertLoading({
          title: 'Portal Session Created Successfully',
          message: 'Please wait while we redirect you to the portal',
        });
        this.window.location.href = response.body.url;
      },
      error: (error) => {
        this.local.alertError({
          message: 'Portal Session Creation Failed',
        });
        this.toastr.error(error.error.message);
      },
    });
  }
}
